const BASE_URL = process.env.REACT_APP_API_HOST ?? 'https://api.rokdim.co.il'
const baseUrl = BASE_URL + '/api/v1'

export default baseUrl
